import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a number as ₹ with Indian digit grouping (₹1,00,000 — never ₹100,000).
 * Presentational only. Falls back to the raw value if it isn't numeric.
 */
@Pipe({ name: 'erInr' })
export class ErInrPipe implements PipeTransform {
  private fmt = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  private fmtWhole = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

  transform(value: number | string | null | undefined, digits: 'auto' | 'whole' | 'paise' = 'auto'): string {
    if (value === null || value === undefined || value === '') { return '—'; }
    const n = typeof value === 'number' ? value : parseFloat(String(value).replace(/[₹,\s]/g, ''));
    if (isNaN(n)) { return String(value); }
    if (digits === 'whole') { return this.fmtWhole.format(n); }
    if (digits === 'paise') { return this.fmt.format(n); }
    return Number.isInteger(n) ? this.fmtWhole.format(n) : this.fmt.format(n);
  }
}
